var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame427321897(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2737_8686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 56,
    height: 56,
    rx: 11.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7071 20.2929C37.3166 19.9024 36.6834 19.9024 36.2929 20.2929L30.2929 26.2929C30.1054 26.4804 30 26.7348 30 27V30C30 30.2653 30.1054 30.5196 30.2929 30.7071C30.4804 30.8947 30.7348 31 31 31L34 31C34.2652 31 34.5196 30.8947 34.7071 30.7071L40.7071 24.707C40.8946 24.5195 41 24.2652 41 23.9999C41 23.7347 40.8946 23.4804 40.7071 23.2928L37.7071 20.2929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 29C23.3431 29 22 30.3432 22 32C22 33.6569 23.3431 35 25 35H35C35.5523 35 36 35.4478 36 36C36 36.5523 35.5523 37 35 37H31C30.4477 37 30 37.4478 30 38C30 38.5523 30.4477 39 31 39H35C36.6569 39 38 37.6569 38 36C38 34.3432 36.6569 33 35 33H25C24.4477 33 24 32.5523 24 32C24 31.4478 24.4477 31 25 31H27C27.5523 31 28 30.5523 28 30C28 29.4478 27.5523 29 27 29H25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2737_8686",
    x: 0.666667,
    y: 0.833333,
    width: 60.6667,
    height: 60.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.16667,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2737_8686"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2737_8686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2737_8686",
    result: "effect2_dropShadow_2737_8686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2737_8686",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame427321897);
export default __webpack_public_path__ + "static/media/Frame 427321897.7089544f3569a1b8e86b1b832315b878.svg";
export { ForwardRef as ReactComponent };